import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "@layout/main-layout/main-layout.component";
import { requiresSalubiPlus } from "@shared/guards/salubi-plus.guard";
import {
	hasAnyFaceScanAccess,
	hasDoneFaceScan,
	hasFaceScanAccess,
} from "./guards/face-scan.guard";

export default [
	{
		path: "face-scan",
		component: MainLayoutComponent,
		canActivate: [hasAnyFaceScanAccess],
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./face-scan.component").then((c) => c.FaceScanComponent),
				canActivate: [hasDoneFaceScan],
			},
			{
				path: "introduction",
				loadComponent: () =>
					import(
						"./face-scan-introduction/face-scan-introduction.component"
					).then((c) => c.FaceScanIntroductionComponent),
				canActivate: [requiresSalubiPlus, hasFaceScanAccess],
			},
			{
				path: "profile",
				loadComponent: () =>
					import(
						"./face-scan-user-information/face-scan-user-information.component"
					).then((c) => c.FaceScanUserInformationComponent),
				canActivate: [requiresSalubiPlus, hasFaceScanAccess],
			},
			{
				path: "consent",
				loadComponent: () =>
					import("./face-scan-consent/face-scan-consent.component").then(
						(c) => c.FaceScanConsentComponent,
					),
				canActivate: [requiresSalubiPlus, hasFaceScanAccess],
			},
			{
				path: "scan",
				loadComponent: () =>
					import("./face-scan-scan/face-scan-scan.component").then(
						(c) => c.FaceScanScanComponent,
					),
				canActivate: [requiresSalubiPlus, hasFaceScanAccess],
			},
			{
				path: ":healthProfile",
				loadComponent: () =>
					import("./face-scan-history/face-scan-history.component").then(
						(c) => c.FaceScanHistoryComponent,
					),
			},
		],
	},
] satisfies Routes;
